import { create } from "zustand";

interface ProjectState {
  n8nUrl: string;
  projectId: string | null;
  activeWorkspaceId: string | null;
  proxyIframeUrl: string | null;
  cliConnected: boolean;
  claudeRunning: boolean;
  consoleLines: string[];

  setN8nUrl: (url: string) => void;
  setProjectId: (id: string | null) => void;
  setActiveWorkspaceId: (id: string | null) => void;
  setProxyIframeUrl: (url: string | null) => void;
  setCliConnected: (connected: boolean) => void;
  setClaudeRunning: (running: boolean) => void;
  addConsoleLine: (line: string) => void;
}

export const useProjectStore = create<ProjectState>((set) => ({
  n8nUrl: "",
  projectId: null,
  activeWorkspaceId: null,
  proxyIframeUrl: null,
  cliConnected: false,
  claudeRunning: false,
  consoleLines: [],

  setN8nUrl: (url) => set({ n8nUrl: url }),
  setProjectId: (id) => set({ projectId: id }),
  setActiveWorkspaceId: (id) => set({ activeWorkspaceId: id }),
  setProxyIframeUrl: (url) => set({ proxyIframeUrl: url }),
  setCliConnected: (connected) => set({ cliConnected: connected }),
  setClaudeRunning: (running) => set({ claudeRunning: running }),
  addConsoleLine: (line) => set((state) => ({ consoleLines: [...state.consoleLines, line] })),
}));
